import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { Title } from '../../components/typography';

const PaperColumn = styled.div`
  border-bottom: ${(props) =>
    props.lastColumn ? '0px solid #e6ecf8' : '1px solid #e6ecf8'};
  margin: 0 auto;
  padding: 2rem;
  width: 100%;
  @media (min-width: 1080px) {
    border-bottom: 0px solid #e6ecf8;
    border-right: ${(props) =>
      props.lastColumn ? '0px solid #e6ecf8' : '1px solid #e6ecf8'};
    flex-direction: row;
  }
`;
const PaperIcon = styled.div`
  color: #0bd8a2;
  font-size: 54px;
  margin-bottom: 1.45rem;
  text-align: center;
`;
const BarContent = styled.div`
  background-color: #9e9e9e1f;
  border-radius: 13px;
  padding: 3px;
`;
const Bar = styled.div`
  background-color: #0bd8a2;
  width: ${(props) => props.perc};
  height: 20px;
  border-radius: 10px;
`;
const Paper = ({ icon, columnTitle, knowledgeList, lastColumn }) => (
  <PaperColumn lastColumn={lastColumn}>
    <PaperIcon>{icon}</PaperIcon>
    <Title fontWeight={800}>{columnTitle}</Title>
    {knowledgeList.map((data, index) => (
      <div key={index}>
        <label>{data.label}</label>
        <BarContent>
          <Bar perc={data.perc} />
        </BarContent>
      </div>
    ))}
  </PaperColumn>
);

Paper.propTypes = {
  icon: PropTypes.node.isRequired,
  columnTitle: PropTypes.string.isRequired,
  knowledgeList: PropTypes.array.isRequired,
  lastColumn: PropTypes.bool.isRequired,
};

export default Paper;
